/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

export const DeliveryTipsSelectButton = React.forwardRef((props, ref) => {
  const { tipPercentageButtonId, value, onClickHandler, disabled, children, checked, labelText } = props;

  return (
    <StyledSelectButton className={checked ? 'checked' : ''}>
      <input
        id={tipPercentageButtonId}
        type="radio"
        value={value}
        name="percentage"
        ref={ref}
        onChange={onClickHandler}
        disabled={disabled}
        checked={checked}
      />
      <label htmlFor={tipPercentageButtonId}>{children}</label>
      <label htmlFor={tipPercentageButtonId}>{labelText}</label>
    </StyledSelectButton>
  );
});

export const StyledSelectButton = styled('div')`
  min-width: 85px;
  min-height: 48px;
  position: relative;
  margin: 5px;
  border: solid 1px #5b6770;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  background: #fff;
  & label {
    cursor: pointer;
    z-index: 90;
    width: 100%;
    height: 100%;
    color: ${(props) => props.theme.text};
    font-size: 14px;
    & svg {
      height: 18px;
      margin: 0;
    }
    &:last-of-type {
      font-size: 11px;
    }
  }
  &.checked {
    border: solid 2px #dd0031;
    & label {
      color: #dd0031;
    }
  }
  & input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
  }
  & input[type='radio'] {
    opacity: 0.011;
    z-index: 100;
    &:disabled {
      cursor: auto;
    }
    &:disabled + label {
      background: ${(props) => props.theme.disabled};
      color: ${(props) => props.theme.text};
      border-color: ${(props) => props.theme.text};
      cursor: auto;
    }
  }
`;

DeliveryTipsSelectButton.propTypes = {
  tipPercentageButtonId: PropTypes.string,
  value: PropTypes.string,
  onClickHandler: PropTypes.func,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  children: PropTypes.string,
  labelText: PropTypes.string,
};

DeliveryTipsSelectButton.defaultProps = {
  tipPercentageButtonId: '',
  value: '',
  onClickHandler: () => {},
  disabled: false,
  checked: false,
  children: '',
  labelText: '',
};

export default DeliveryTipsSelectButton;
